import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useCustomUtilsHistory } from 'services/react-router-custom-history';
import { ArrowLeft, Bank, MoreIcon } from 'components/Icons';
import Link from './components/Link';
import { Dropdown } from 'components/Dropdown';
import { Clock } from 'styled-icons/fluentui-system-regular';

// Definindo as cores, fontes e outros valores como variáveis
const colorNeutral100 = '#1A1A1A'; // Substitua pelas suas cores reais
const colorNeutral0 = '#fff'; // Substitua pelas suas cores reais
const fontSize16 = '16px'; // Substitua pelas suas variáveis reais
const fontSize20 = '20px'; // Substitua pelas suas variáveis reais
const fontWeightSemiBold = '600'; // Substitua pelo valor real da sua fonte

interface ISubheader {
  onReturn?: () => void;
  noHasReturn?: boolean;
  title?: string;
  status?: any;
  onClickDataAgency?: () => void;
  onClickHistory?: () => void;
}

// Estilizando os componentes com styled-components
const Header = styled.header<{ hideHeader: boolean }>`
  top: 5.6rem;
  position: sticky;
  background: ${colorNeutral0};
  display: flex;
  align-items: center;
  min-height: 5.6rem;
  padding: 0 3.2rem;
  justify-content: center;

  border-bottom: 0.0625rem solid #e7e9ec;
`;

const Container = styled.div`
  display: flexbox;
  align-items: center;
  justify-content: space-between;
  list-style: none;
  width: 130rem;
`;

const ContainerTitle = styled.div`
  gap: 1.5rem;
  width: 100%;
  align-items: center;
`;

const BackButton = styled.div`
  display: flex;

  align-items: center;
  flex-direction: row;
  text-decoration: none;
  justify-content: space-between;
  color: ${colorNeutral100};
  font-size: ${fontSize20};
  font-weight: ${fontWeightSemiBold};
`;

const Links = styled.div`
  gap: 1.5rem;
  display: flex;
  align-items: center;
  flex-direction: row;
`;
const Icon = styled.div`
  font-size: ${fontSize16};
  cursor: pointer;
`;
const Title = styled.p`
  margin-bottom: 0;
`;
const WrapperbuttonDropDown = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 24px;
`;
const SubHeader = ({
  title,
  onReturn,
  noHasReturn,
  onClickDataAgency,
  status,
  onClickHistory,
}: ISubheader) => {
  const hideHeader = window !== window.parent;
  const [isMobile, setIsMobile] = useState(false);
  const history = useCustomUtilsHistory();
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 800);
    };

    // Verificar no carregamento
    checkMobile();

    // Adicionar event listener para mudanças de largura
    window.addEventListener('resize', checkMobile);

    // Limpar event listener
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);
  const handleBack = () => {
    if (onReturn) {
      onReturn();
    } else {
      history.push('/ClientArea');
    }
  };

  return (
    <Header data-testid="sub-header" hideHeader={hideHeader}>
      <Container>
        <ContainerTitle>
          <BackButton data-testid="back-button">
            <div
              style={{ display: 'flex', gap: ' 24px', alignItems: 'center' }}
            >
              {!noHasReturn && (
                <Icon onClick={() => !noHasReturn && handleBack()}>
                  <ArrowLeft />
                </Icon>
              )}

              <Title
                data-testid="title"
                style={{ fontSize: noHasReturn ? '32px' : undefined }}
              >
                {title}
              </Title>
            </div>
            {noHasReturn && (
              <Links>
                {isMobile ? (
                  <Dropdown
                    title={false}
                    width="24rem"
                    element={<MoreIcon />}
                    height="4.5rem"
                    position="-.3"
                  >
                    <WrapperbuttonDropDown>
                      <Link
                        text={'Dados da imobiliária'}
                        onClick={onClickDataAgency}
                        icon={<Bank />}
                      />
                    </WrapperbuttonDropDown>
                    <WrapperbuttonDropDown>
                      <Link
                        text={'Histórico'}
                        onClick={onClickHistory}
                        icon={<Clock size={24} />}
                      />
                    </WrapperbuttonDropDown>
                  </Dropdown>
                ) : (
                  <>
                    <Link
                      text={'Dados da imobiliária'}
                      onClick={onClickDataAgency}
                      icon={<Bank />}
                    />
                    <Link
                      text={'Histórico'}
                      onClick={onClickHistory}
                      icon={<Clock size={24} />}
                    />
                  </>
                )}
              </Links>
            )}
          </BackButton>
          {status && status}
        </ContainerTitle>
      </Container>
    </Header>
  );
};

export default SubHeader;
